namespace TabAurous.OMS {
    export interface PosCustomerMasterForm {
        PosCustomerCode: Serenity.StringEditor;
        Prefix: Common.CustomerPrefixEditor;
        FirstName: Serenity.StringEditor;
        LastName: Serenity.StringEditor;
        Gender: POSCustomerMasterEditor;
        MaritialStatus: MaritialStatusEditor;
        Mobile: Serenity.StringEditor;
        Mobile2: Serenity.StringEditor;
        TelR: Serenity.StringEditor;
        TelO: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        ImagePath: Serenity.ImageUploadEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        ReligonId: Serenity.LookupEditor;
        Address: Serenity.StringEditor;
        CountryId: Serenity.LookupEditor;
        StateId: Serenity.LookupEditor;
        CityId: Serenity.LookupEditor;
        Pin: Serenity.StringEditor;
        NationalityId: Serenity.LookupEditor;
        ParentId: Serenity.ServiceLookupEditor;
        RefId: Serenity.ServiceLookupEditor;
        IsDisabled: Serenity.BooleanEditor;
        AllowCredit: Serenity.BooleanEditor;
        CreditLimit: Serenity.DecimalEditor;
        HomeBranchId: Serenity.LookupEditor;
        PanNumber: Serenity.StringEditor;
    }

    export class PosCustomerMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.PosCustomerMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PosCustomerMasterForm.init)  {
                PosCustomerMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = Common.CustomerPrefixEditor;
                var w2 = POSCustomerMasterEditor;
                var w3 = MaritialStatusEditor;
                var w4 = s.ImageUploadEditor;
                var w5 = s.DateEditor;
                var w6 = s.LookupEditor;
                var w7 = s.ServiceLookupEditor;
                var w8 = s.BooleanEditor;
                var w9 = s.DecimalEditor;

                Q.initFormType(PosCustomerMasterForm, [
                    'PosCustomerCode', w0,
                    'Prefix', w1,
                    'FirstName', w0,
                    'LastName', w0,
                    'Gender', w2,
                    'MaritialStatus', w3,
                    'Mobile', w0,
                    'Mobile2', w0,
                    'TelR', w0,
                    'TelO', w0,
                    'Email', w0,
                    'ImagePath', w4,
                    'BirthDate', w5,
                    'Anniversary', w5,
                    'ReligonId', w6,
                    'Address', w0,
                    'CountryId', w6,
                    'StateId', w6,
                    'CityId', w6,
                    'Pin', w0,
                    'NationalityId', w6,
                    'ParentId', w7,
                    'RefId', w7,
                    'IsDisabled', w8,
                    'AllowCredit', w8,
                    'CreditLimit', w9,
                    'HomeBranchId', w6,
                    'PanNumber', w0
                ]);
            }
        }
    }
}
